"use client";

import { WhoItsForSection } from "@/components/sections/who-its-for";
import { whoItsFor } from "@/lib/data/services-content-narrative-engineering";

export function WhoItsFor() {
  return (
    <WhoItsForSection
      eyebrow={whoItsFor.eyebrow}
      title={whoItsFor.title}
      segments={whoItsFor.segments}
      accent={whoItsFor.accent}
      gridCols={whoItsFor.gridCols}
    />
  );
}
